<template>
  <v-flex data-qa="opensavingsaccount-flex-9vb55k">
    <!-- TODO: MOVE CONFIRMATION MODAL TO PRODUCT OFFERS -->
    <Loader v-if="loaderEnabled"/>
    <!-- Account Opening Confirmation Modal -->
    <Modal
      v-if="
        enableCASAPage &&
        !createCasa &&
        config[currentPage] &&
        offerInfo &&
        currentPage === 'savingsAccReview'
      "
      :config="modalConfig.accOpenConfirmation"
      @btn1Action="setOtpComp"
      @btn2Action="onCancel"
    >
      <span slot="modalContent" data-qa="opensavingsaccount-span-tjkcv2">
        <v-row no-gutters class="pt-4" data-qa="opensavingsaccount-row-dnwqg">
          <font class="body-2 font-weight-regular">
            {{ accountConfig.offerInfo.productSummary.productType === 'TXLA' ? $t("openSavingsAcc.lisaOpenWarning") : $t("openSavingsAcc.askForAccOpen") }} {{ accountConfig.offerInfo.label }} {{ '?' }}
          </font>
        </v-row>
      </span>
    </Modal>

    <!-- Account Opening Success Modal -->
    <Modal
      v-if="enableCASAPage &&
        offerList.savingsAccConfirm &&
        currentPage !== 'savingsAccReview'
      "
      :config="modalConfig.accOpeningSuccess"
    >
      <span slot="modalContent" data-qa="opensavingsaccount-span-w2xmhl">
        <v-flex xs12 sm12 md12 lg12 xl12 data-qa="opensavingsaccount-flex-8stp">
          <!-- Account opened success msg -->
          <v-row class="pb-6 text-h5 font-weight-bold black--text" data-qa="opensavingsaccount-row-zd1r1l">
            {{ $t("openSavingsAcc.successMsg.greet") }}
          </v-row>
          <v-row class="pb-6" v-if="accDetails.accountType === 'NACC'" data-qa="opensavingsaccount-row-b1ddjl">
            {{ $t("openSavingsAcc.successMsg.greetOpenNotice") }}
          </v-row>
          <v-row class="pb-6" v-if="accDetails.accountType === 'TXLA'" data-qa="opensavingsaccount-row-ig1w1">
            {{ $t("openSavingsAcc.successMsg.greetOpenLisa") }}
          </v-row>
          <v-row no-gutters class="mt-6 pl-3" data-qa="opensavingsaccount-row-bz400l">
            <DisplayDetails
              :config="{
                dataList: offerList.savingsAccConfirm.content,
                translation: 'openSavingsAcc.label',
              }"
            />
          </v-row>
          <v-row v-if="isBalanceMin()" class="pt-4 pl-3" data-qa="opensavingsaccount-row-3n2ikj">
            <v-alert icon="mdi-information-outline" class="v-alert--info" data-qa="opensavingsaccount-alert-lmpew">
              <font class="body-2 font-weight-regular">{{
                $t("openSavingsAcc.minBalanceAlert")
              }}</font>
            </v-alert>
          </v-row>
          <!-- Buttons -->
          <v-row justify="end" no-gutters class="py-2 mt-6" data-qa="opensavingsaccount-row-sq71v7">
            <v-btn @click="routeTo('home')" :color="primaryColor"
              text
              class="text-capitalize"
              data-qa="opensavingsaccount-btn-yaoo9">{{ $t("openSavingsAcc.btn.toHome") }}</v-btn
            >
            <v-btn
              v-if="
                nominatedAccountsConfig.enableNominatedAccountFeatures &&
                (accountConfig.type === 'SVGS' || accountConfig.offerInfo.productSummary.productType === 'TXNA') &&
                !['NACC', 'TXLA'].includes(accountConfig.offerInfo.productSummary.productType) &&
                isUpdateNominatedAccPermitted
              "
              @click="routeTo('updateNominatedAcc')"
              :color="primaryColor"
              outlined
              class="text-none py-2 px-4 ml-1"
              data-qa="opensavingsaccount-btn-zwhbnq">
              <font :color="primaryColor">{{ $t("openSavingsAcc.btn.updateNominatedAcc") }}</font>
            </v-btn>
            <v-btn
              @click="routeTo('viewAcc')"
              :color="primaryColor"
              class="white--text text-none py-2 px-4 ml-1"
              data-qa="opensavingsaccount-btn-xi5vr">{{ $t("openSavingsAcc.btn.viewAcc") }}</v-btn
            >
          </v-row>
        </v-flex>
      </span>
    </Modal>
    <!-- Acc Opening Error Modal -->
    <Modal
      v-if="savingsAccError"
      :config="modalConfig.savingsAccError"
      @btn1Action="savingsAccError=false; onCancel()"
      @btn2Action="routeTo('home')"
    >
    </Modal>
    <!-- OTP Section -->
    <Modal
      v-if="!enableCASAPage && enableOTP && showOTPScreen"
      :config="modalConfig.otp"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="opensavingsaccount-span-g1j2jb">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
  </v-flex>
</template>

<script>
import '@/styles/pages/accounts/openSavingsAcc.scss'
import DisplayDetails from '@/views/common/DisplayDetails.vue'
import OtpInput from '@/components/common/OtpInput.vue'
import event from '@/util/event'
import commonService from '@/service/commonService.js'
import store from '@/core/store'
import preload from '@/util/preload'

export default {
  name: 'OpenSavingsAccount',
  props: {
    accountConfig: Object,
    additionalDetails: Object
  },
  components: {
    OtpInput,
    DisplayDetails,
    Modal: () => import('@/components/common/Modal.vue')
  },
  data () {
    return {
      enableCASAPage: true,
      loaderEnabled: false,
      savingsAccError: false,
      stepNum: null,
      currentPage: 'savingsAccReview',
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      config: {},
      accountId: '',
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        },
        savingsAccError: {
          enabled: false,
          title: this.$t('openSavingsAcc.errorMsg'),
          subtitle: '',
          persistent: true,
          btn1Label: this.$t('openSavingsAcc.tryAgain'),
          btn2Label: this.$t('openSavingsAcc.btn.toHome'),
          width: 650
        },
        accOpenConfirmation: {
          enabled: false,
          title: this.$t('openSavingsAcc.title'),
          subtitle: '',
          persistent: true,
          btn1Label: this.$t('openSavingsAcc.btn.yes'),
          btn2Label: this.$t('openSavingsAcc.btn.no'),
          width: 650
        },
        accOpeningSuccess: {
          enabled: true,
          persistent: true,
          width: 700
        }
      },
      offerInfo: null,
      createCasa: false,
      enableOTP: this.$appSettings.defaultConfigurations.enableOTPForSavingsAcc,
      nominatedAccountsConfig: this.$appSettings.defaultConfigurations.nominatedAccounts,
      showOTPScreen: false,
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      accDetails: {},
      offerList: {
        savingsAccReview: {},
        savingsAccConfirm: {}
      },
      openSavingsErrMsg: null,
      ignoreAgeCheck: false,
      defaultBranchCode: this.$appSettings.defaultConfigurations.loginPageScreens.activateUserScreen.branchCode,
      enableVerifyPersonalDetails: this.$appSettings.defaultConfigurations.consentManagement.enableVerifyPersonalDetails,
      enableTCForAccountOpening: this.$appSettings.defaultConfigurations.consentManagement.enableTCForAccountOpening,
      serviceNotAvailableStatusList: [401, 500],
      isUpdateNominatedAccPermitted: false,
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess
    }
  },
  created () {
    // if the product is eligible for joint account opening then the modal for selecting account operation type
    // would have been shown already - so skip the confirmation modal and show otp modal
    this.offerInfo = this.accountConfig.offerInfo
    if (!this.isSmeLogin && this.accountConfig.type !== 'CACC' && (this.enableVerifyPersonalDetails || this.enableTCForAccountOpening || this.accountConfig.accountOperationTypeDetails?.selectedAccountOperationType)) {
      this.setOtpComp()
    }

    // Fetch Permissions for SME Users
    this.permissions = store.getters['profileStore/profileData']?.permissions
    this.isUpdateNominatedAccPermitted = (this.isSmeLogin && this.enableRoleBasedAccess) ? this.permissions?.includes('VIEW_PAYEES') : true
    this.modalConfig.accOpenConfirmation.title = this.$t('openSavingsAcc.openNew') + ' ' + this.offerInfo.label
    this.modalConfig.accOpenConfirmation.enabled = true
    this.offerList = {
      savingsAccReview: {
        content: {
          minBalance: this.offerInfo.minBal,
          currency: this.offerInfo.currency
        }
      }
    }
    event.$once('IS_OTP_VALID', (valid) => {
      if (valid && !this.enableCASAPage && this.enableOTP && this.showOTPScreen) {
        this.modalConfig.otp.enabled = false
        this.createCasa = true
        this.createCasaAccount()
      } else {
        this.createCasa = false
      }
    })
    event.$on('OTP_RESENT', (val) => {
      this.modalConfig.otp.enableSave = true
    })
  },
  mounted () {
    this.config = this.offerList
  },
  methods: {
    onCancel () {
      this.$emit('cancelDialog')
      this.enableCASAPage = false
    },
    onOtpModalClose () {
      this.$emit('cancelDialog')
      this.enableCASAPage = false
      this.showOTPScreen = false
      this.modalConfig.otp.enabled = false
    },
    routeTo (to) {
      switch (to) {
        case 'home':
          this.$router.push('/home')
          break
        case 'viewAcc':
          this.$router.push({
            name: 'AccountDetails',
            params: this.accDetails
          })
          break
        case 'updateNominatedAcc':
          this.$router.push({
            name: 'UpdateNominatedAccount',
            params: { accDetails: this.accDetails, accountId: this.accountId, accountCurrency: this.accDetails.currency }
          })
          break
        default:
          break
      }
    },
    getTickIcon () {
      return this.getSvgIconSrc('Tick')
    },
    getErrorIcon () {
      return this.getSvgIconSrc('Error')
    },
    setOtpComp () {
      if (this.enableOTP) {
        // create acc WITH otp Authentication
        this.enableCASAPage = false
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
      } else {
        // create acc WITHOUT otp Authentication
        this.enableCASAPage = false
        this.createCasaAccount()
      }
    },
    async createLisaInvestor (data) {
      await commonService.createLisaInvestor(data).then((res) => {
        if (res.data && res.data.status === 400 && res.causes && res.causes[0].code === 'FEISAC-000005') {
          this.openSavingsErrMsg = this.$t('systemMessages.customMessages.FEISAC-000005.message')
          this.savingsAccError = true
          this.modalConfig.savingsAccError.enabled = true
          this.modalConfig.savingsAccError.subtitle = this.openSavingsErrMsg
        }
        if (!res.investorID) {
          if (res.lisaAppStatusCd === 'REJECTED') {
            this.openSavingsErrMsg = this.$t('openSavingsAcc.lisaRejected', { reason: res.rejectionReason })
            this.modalConfig.savingsAccError.subtitle = this.openSavingsErrMsg
          }
          this.savingsAccError = true
          this.modalConfig.savingsAccError.enabled = true
        }
        if (res.lisaAppStatusCd === 'ACCEPTED' && res.hmrcCode === 'INVESTOR_ALREADY_EXISTS') {
          this.ignoreAgeCheck = true
        }
      })
      this.modalConfig.accOpenConfirmation.enabled = true
    },
    isCurrencyFormatted (balance) {
      if (!isNaN(balance)) {
        return this.$formatter.currency.format(balance)
      } else {
        return balance
      }
    },
    isBalanceMin () {
      const minimumBalance = this.accountConfig.offerInfo.minBal
      if (!isNaN(minimumBalance)) {
        return Boolean(minimumBalance > 0)
      }
    },
    getConfirmStepData (response) {
      this.accountId = response.accountId
      this.offerList.savingsAccConfirm = {
        response,
        customerName: response.accountDetails.customerName,
        offerInfo: this.offerInfo,
        type: this.accountConfig.type,
        content: [
          {
            label: 'accountNumber',
            value: response.accountId
          },
          {
            label: 'dateOpened',
            value: response.createDateTime
              ? this.$formatter.formatDate(response.createDateTime.substr(0, 10))
              : ''
          },
          {
            label: 'currency',
            value: this.offerInfo.currency
          },
          {
            label: 'minBalance',
            value: this.$formatter.currency.format(this.offerInfo.minBal, this.offerInfo.currency, this.$appSettings.defaultConfigurations.showDecimalPartInOpenAcountMinMaxAmount)
          }
        ]
      }
      if (response?.accountDetails?.jointCustomerDetails) {
        this.offerList.savingsAccConfirm.content.push(
          {
            label: 'jointAccount',
            value: this.$t('common.yes')
          },
          {
            label: 'jointAccountOwner',
            value: `${response.accountDetails.jointCustomerDetails[0].jointCustomerName} - ${response.accountDetails.jointCustomerDetails[0].jointCustomerId}`
          },
          {
            label: 'modeOfOperation',
            value: this.$t(`systemEnums.modeOfOperations.${response.accountDetails.modeOfOperation}`)
          }
        )
      }
      return this.offerList.savingsAccConfirm
    },
    async createCasaAccount () {
      try {
        this.loaderEnabled = true
        const { accountOperationTypeDetails: { selectedAccountOperationType = 'SOLE', selectedJointAccountHolder = null, selectedModeOfOperation = 'SOLE' } = {} } = this.accountConfig
        this.accDetails = {}
        this.modalConfig.savingsAccError.subtitle = this.$t('openSavingsAcc.contactCustomerService')
        if (this.accountConfig.offerInfo.productSummary.productType === 'TXLA') {
          const lisaData = {
            customerID: JSON.parse(sessionStorage.getItem('username')),
            channelID: 'DOB'
          }
          const customerDetails = store.getters['profileStore/profileData'].customerDetails
          if (!customerDetails.lastName || !customerDetails.taxIDNumber) {
            this.savingsAccError = true
            this.modalConfig.savingsAccError.enabled = true
            this.openSavingsErrMsg = this.$t('openSavingsAcc.noLastNameNiNo')
            this.modalConfig.savingsAccError.subtitle = this.openSavingsErrMsg
          } else {
            await this.createLisaInvestor(lisaData)
          }
        }
        if (!this.savingsAccError) {
          const data = {
            customerId: JSON.parse(sessionStorage.getItem('username')),
            branchCode: this.defaultBranchCode,
            productId: this.offerInfo.offerId,
            accountOwnership: selectedAccountOperationType,
            accountAdditionalDetails: null,
            ignoreAgeCheck: this.ignoreAgeCheck
          }
          if (selectedAccountOperationType === 'JOINT') {
            data.accountAdditionalDetails = {
              modeOfOperation: selectedModeOfOperation,
              jointCustomerDetails: [{ customerId: selectedJointAccountHolder.jointCustomerId }]
            }
          }
          if (this.additionalDetails) {
            data['custom-fields'] = {
              additionalProperties: this.additionalDetails
            }
          }
          const resp = await commonService.createCasaAccount(data)
          if (resp && resp.accountId) {
            this.savingsAccError = false
            let response = this.accountConfig.offerInfo.productSummary.productType === 'TXNA' ? await commonService.getNoticeAccountBalances(resp.accountId) : await commonService.getAccountBalances(resp.accountId)
            if (!this.accountConfig.offerInfo.productSummary.productType === 'TXNA') {
              response = response.balances.filter(ele => ele.balanceType === 'INTERIMCLEARED')
            }
            await preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
            if ('accountDetails' in resp) {
              this.enableCASAPage = true
              this.accDetails = {
                product: resp.accountDetails,
                balance: (this.accountConfig.offerInfo.productSummary.productType === 'TXNA' ? response?.balanceInformation?.availableBalance : response[0]?.amount?.amount) || 0,
                accountId: resp.accountId,
                accountName: resp.accountDetails.customerName,
                accountType: this.accountConfig.offerInfo.productSummary.productType || this.accountConfig.type,
                currency: this.offerInfo.currency
              }
              this.createCasa = false
              this.currentPage = 'savingsAccConfirm'
              this.getConfirmStepData(resp)
            }
            if (this.enableTCForAccountOpening && this.accountConfig.consent) {
              const consentInfo = {
                consentEntityId: resp.accountId,
                consentEntityType: 'ACCOUNT',
                consentGivenBy: JSON.parse(sessionStorage.getItem('username')),
                channelCode: 'DOB',
                consents: this.accountConfig.consent
              }
              const consentResp = await commonService.storeEntityConsent(consentInfo)
              if (!consentResp?.entityId) {
                const body = {
                  accountAdditionalDetails: {
                    postingRestriction: 'CREDIT'
                  }
                }
                await commonService.updateARI(resp.accountId, body)
              }
            }
            // return res
          } else {
            if (resp && resp.causes) {
              this.openSavingsErrMsg = resp.causes[0].message || null
              this.modalConfig.savingsAccError.subtitle = this.openSavingsErrMsg
            }
            this.savingsAccError = true
            this.modalConfig.savingsAccError.enabled = true
          }
        }
        this.loaderEnabled = false
        this.modalConfig.accOpenConfirmation.enabled = true
      } catch (e) {
        console.log(e)
      }
    },
    isServiceUnavailable (response) {
      const status = response?.data?.status || response?.status
      return this.serviceNotAvailableStatusList.includes(status) ? true : false
    }
  },
  watch: {
    showOTPScreen () {
      if (this.enableOTP && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  }
}
</script>
